import { CacheProvider } from "@emotion/react";
import { ThemeProvider } from "@mui/material";

import { MaterialUIControllerProvider } from "@/contexts/mui-context";
import themes from "@/themes";
import { Themes } from "@/typings/theme";
import createEmotionCache from "@/utils/create-emotion-cache";

const clientSideEmotionCache = createEmotionCache();

type StyleProvidersProps = {
  children: React.ReactNode;
};

const themeName = (import.meta.env.VITE_THEME || "defaultTheme") as keyof Themes;
const theme = themes[themeName];

export default function StyleProviders({ children }: StyleProvidersProps) {
  return (
    <MaterialUIControllerProvider>
      <ThemeProvider theme={theme}>
        <CacheProvider value={clientSideEmotionCache}>{children}</CacheProvider>
      </ThemeProvider>
    </MaterialUIControllerProvider>
  );
}
